
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/coverage/microdeposit-events",
      function () {
        return require("private-next-pages/docs/auth/coverage/microdeposit-events.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/coverage/microdeposit-events"])
      });
    }
  